import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorRequired } from '../FormFields/ErrorRequired';
import { ErrorEmailInvalid } from '../FormFields/ErrorEmailInvalid';

export class EmailFormInput extends React.Component {
  render = () => {
    const inputClasses = classNames({
      'form-group': true,
      'has-error': this.props.isDisplayRequiredFailed || this.props.isDisplayInvalid,
    });

    return (
    <div className={inputClasses} >
      <label className="bold" htmlFor={this.props.id}>{ this.props.labelText }
        <ErrorRequired isDisplay={this.props.isDisplayRequiredFailed } />
        <ErrorEmailInvalid isDisplay={this.props.isDisplayInvalid } />
        <input type="email" className="form-control"
          value={this.props.email || ''}
          onChange={this.props.onChange}
          name={this.props.emailPropertyName}
          id={this.props.id}
        />
      </label>
    </div>
    );
  }
}

EmailFormInput.propTypes = {
  labelText: PropTypes.string,
  email: PropTypes.string,
  onChange: PropTypes.func,
  isDisplayRequiredFailed: PropTypes.bool,
  isDisplayInvalid: PropTypes.bool,
  emailPropertyName: PropTypes.string.isRequired,
  id: PropTypes.string,
};
